import styled from 'styled-components';


// Container
export const PodcastContainer = styled.div.attrs(() => ({
  className: 'bg-gray-300 py-10 px-5',
}))``;

// Grid Container
export const PodcastGrid = styled.div.attrs(() => ({
  className: 'max-w-full mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8',
}))``;

// Podcast Card
export const PodcastCard = styled.div.attrs(() => ({
  className: 'bg-gray-100 rounded-lg shadow-lg overflow-hidden transition-all duration-300 ease-in-out',
}))``;

// Podcast Image
export const PodcastImage = styled.img.attrs(() => ({
  className: 'w-full h-72 object-cover transition-all duration-300 ease-in-out',
}))``;

// Card Content
export const PodcastContent = styled.div.attrs(() => ({
  className: 'p-6 relative', // For positioning the description
}))``;

// Date Text
export const PodcastDate = styled.p.attrs(() => ({
  className: 'text-sm text-gray-500',
}))``;

// Title Text
export const PodcastTitle = styled.h2.attrs(() => ({
  className: 'text-xl font-semibold mt-3 cursor-pointer',
}))``;

// Description Text
export const PodcastDescription = styled.p.attrs(() => ({
  className: 'overflow-hidden transition-all duration-300 ease-in-out max-h-0 opacity-0 text-gray-700 mt-3',
}))``;

// Hover Effects for Podcast Card
export const HoverablePodcastCard = styled(PodcastCard)`
  &:hover {
    ${PodcastTitle} {
      color: #1D4ED8; /* Change to blue-500 on hover */
    }

    ${PodcastDescription} {
      max-height: 10rem; /* Show the description on hover */
      opacity: 100;
    }

    ${PodcastImage} {
      opacity: 0.5;
    }
  }
`;
